import LegalLayout, { LegalSection } from "@/components/LegalLayout";

const Privacidad = () => (
  <LegalLayout title="Política de Privacidad">
    <LegalSection title="1. Responsable del tratamiento">
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Responsable: <strong>CROC LAB, SOCIEDAD LIMITADA</strong> · NIF:
          B88810940
        </li>
        <li>Domicilio social: C/ Suïssa 10, 2º B, 46006 Valencia, España</li>
        <li>
          Establecimiento: C/ del Dr. Romagosa 10, Ciutat Vella, 46002 Valencia,
          España
        </li>
        <li>
          Email de contacto en materia de protección de datos:{" "}
          <a
            href="mailto:croclab.valencia@gmail.com"
            className="text-brand-pink font-semibold hover:underline"
          >
            croclab.valencia@gmail.com
          </a>
        </li>
      </ul>
      <p>
        Esta política se adapta al Reglamento (UE) 2016/679 (RGPD) y a la Ley
        Orgánica 3/2018 (LOPDGDD).
      </p>
    </LegalSection>
    <LegalSection title="2. Qué datos recogemos y para qué">
      <ul className="list-disc pl-5 space-y-3">
        <li>
          <strong>Formulario de contacto:</strong> nombre, email, tipo de
          consulta y mensaje. Finalidad: atender y responder a tu consulta
          (clientes, colaboraciones, prensa o negocio).
        </li>
        <li>
          <strong>Consultas por email:</strong> si nos escribes a nuestra
          dirección de correo, tratamos tus datos de contacto y el contenido del
          mensaje para gestionar tu solicitud.
        </li>
        <li>
          <strong>Newsletter y comunicaciones comerciales:</strong> no está
          activa actualmente. Si se habilita en el futuro, solo enviaremos
          comunicaciones a quienes lo hayan aceptado expresamente, y podrás
          darte de baja en cualquier momento.
        </li>
        <li>
          <strong>Pedidos y reservas:</strong> no están habilitados en este
          sitio. Si se activan más adelante, informaremos de los tratamientos
          asociados antes de recoger ningún dato.
        </li>
        <li>
          <strong>Redes sociales:</strong> las interacciones en nuestros
          perfiles oficiales (Instagram, TikTok, Facebook) se rigen por las
          políticas de cada plataforma; CROC LAB solo trata esos datos para
          gestionar la comunidad y responder mensajes.
        </li>
        <li>
          <strong>Analítica web:</strong> solo si aceptas las cookies de
          analítica, se recogen datos de uso anónimos (páginas visitadas, tipo
          de dispositivo y datos similares) para mejorar el sitio.
        </li>
      </ul>
    </LegalSection>
    <LegalSection title="3. Base jurídica">
      <p>
        La base jurídica es tu consentimiento (art. 6.1.a RGPD), otorgado al
        marcar la casilla del formulario o al aceptar las cookies de analítica,
        y el interés legítimo (art. 6.1.f RGPD) para la seguridad y el
        funcionamiento técnico del sitio. Puedes retirar tu consentimiento en
        cualquier momento sin que ello afecte a los tratamientos ya realizados.
      </p>
    </LegalSection>
    <LegalSection title="4. Conservación">
      <p>
        Los datos de contacto se conservan durante el tiempo necesario para
        gestionar tu consulta y, posteriormente, durante los plazos legales de
        prescripción aplicables. Los datos de analítica se conservan según los
        plazos de la herramienta utilizada.
      </p>
    </LegalSection>
    <LegalSection title="5. Destinatarios y encargados de tratamiento">
      <p>
        No cedemos tus datos a terceros. Los proveedores que prestan servicios
        técnicos al sitio (proveedor de alojamiento web y, si la aceptas, la
        herramienta de analítica PostHog) actúan como encargados del tratamiento
        conforme al art. 28 RGPD.
      </p>
    </LegalSection>
    <LegalSection title="6. Transferencias internacionales">
      <p>
        Si alguno de los proveedores tecnológicos indicados procesara datos
        fuera del Espacio Económico Europeo, dichas transferencias se
        realizarían con las garantías exigidas por el RGPD (decisión de
        adecuación, cláusulas contractuales tipo u otro mecanismo válido).
      </p>
    </LegalSection>
    <LegalSection title="7. Tus derechos y cómo ejercerlos">
      <p>
        Puedes ejercer los derechos de acceso, rectificación, supresión,
        oposición, limitación del tratamiento y portabilidad escribiendo a{" "}
        <a
          href="mailto:croclab.valencia@gmail.com"
          className="text-brand-pink font-semibold hover:underline"
        >
          croclab.valencia@gmail.com
        </a>
        , indicando el derecho que deseas ejercer. También puedes presentar una
        reclamación ante la Agencia Española de Protección de Datos (
        <a
          href="https://www.aepd.es"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-pink font-semibold hover:underline"
        >
          www.aepd.es
        </a>
        ).
      </p>
    </LegalSection>
    <LegalSection title="8. Seguridad y decisiones automatizadas">
      <p>
        Aplicamos medidas técnicas y organizativas adecuadas para proteger tus
        datos. No se toman decisiones automatizadas ni se elaboran perfiles con
        tus datos.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Privacidad;
